import React, { useEffect, useRef, useState } from "react";
import BackArrows from "../../Form/BackArrow/BackArrows";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { getIcons, userRole } from "../../Constant/Constant";
import img from "../../../assets/GLpageSmapleImages/img.svg";
import PropertiesSelectingModel from "./PropertiesSelectingModel";
import { useNavigate } from "react-router-dom";
import PropertiesService from "../../Services/PropertiesService";
import { RiEqualizerLine } from "react-icons/ri";
import { FiChevronDown } from "react-icons/fi";
import SortDropdown from "./SortDropdown";
import PropertiesFilter from "./PropertiesFilter";
import EstimateGeneration from "./EstimateSection/EstimateGeneration";
import EstimateHistoryModel from "./EstimateSection/EstimateHistoryModel";
import { PropertyTypeList } from "../../../Enum";
import { FiSearch } from "react-icons/fi";
import CustomHeading from "../../common/CustomHeading";
import { ToastContainer } from "react-toastify";
import { showInfoToast } from "../../Constant/Notification";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";

const PropertiesListCard = () => {
  const icons = getIcons();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isEstimateModelOpen, setIsEstimateModelOpen] = useState(false);
  const [selectedPropertyName, setSelectedPropertyName] = useState("");
  const [propertyList, setPropertyList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedPropertySaleTypeId , setSelectedPropertySaleTypeId] = useState(null);
  const [selectedPropertyLocationId , setSelectedPropertyLocationId] = useState(null);
  const [nextPrpopertyId, setNextPropertyId] = useState(null);
  const [selectedPropertyType , setSelectedPropertyType] = useState(null);
 
  const [propertyCount, setPropertyCount] = useState({
    allCount: 0,
    layoutCount: 0,
    villaCount: 0,
    acresAndCentsCount: 0,
    apartmentCount: 0,
  });
  
  const [loading, setLoading] = useState(true);

  const [hasMore, setHasMore] = useState(true);
const [isSearching, setIsSearching] = useState(false);
const [pageLoading, setPageLoading] = useState(false);


  const navigate = useNavigate();

  const propertySampleImage = img;

  const PropertyTab = [
    {
      lable: "All Properties",
      count: propertyCount?.allCount,
      id : null,
    },
    {
      lable: "Layout",
      count: propertyCount?.layoutCount,
      id : "fOQZ4CPJQYZikZnFkrxy",
    },
    {
      lable: "Villa",
      count: propertyCount?.villaCount,
      id : "k6QfCzo0QVXutC3MUTfV",
    },
    {
      lable: "Apartment",
      count: propertyCount?.apartmentCount,
      id : "xOl7nFLzvXtqVAcSrvIC",
    },
    // {
    //   lable: "Acres and Cents",
    //   count: 10,
    //   id : "sczwuE4dZNBGlJOfa3wd",
    // },
  ];

  // useEffect(() => {
  //   const getPropertyListCount = async () => {
  //     try {
  //       const response = await PropertiesService.getpropertyListCount();
  //       const data = response.data;
  //       setPropertyCount(prev => ({
  //         ...prev,
  //         allCount: data.allProperties,
  //         layoutCount: data.Layout,
  //         villaCount: data.Villa,
  //         acresAndCentsCount: data.AcresAndCents,
  //         apartmentCount: data.Apartment,
  //       }));
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };
  
  //   getPropertyListCount();
  // }, []);
  

  const getPropertyData = async (isNext = false, reset = false) => {
    if (isNext && (!hasMore || pageLoading)) return;
  
    if (reset) {
      setPropertyList([]);
      setNextPropertyId(null);
      setHasMore(true);
    }
  
    setPageLoading(true);
    setLoading(true);  
    try {
      const body = {
        propertyTypeId: selectedIndex || null,
        searchKey: searchTerm || null,
        propertySaleTypeId: selectedPropertySaleTypeId || null,
        locationId : selectedPropertyLocationId || null,
        limit: 10,
        next: isNext ? nextPrpopertyId : null,

        direction: "next",
      };
      const response = await PropertiesService.getProperties(body);

      const dataTotalCounts = response.data?.totalCounts;
      const dataFilteredCounts = response.data?.filteredCounts;


      setPropertyCount(prev => ({
        ...prev,
        allCount: (dataFilteredCounts.Layout + dataFilteredCounts.Villa   + dataFilteredCounts.Apartment),
        layoutCount: dataFilteredCounts.Layout,
        villaCount: dataFilteredCounts.Villa,
        acresAndCentsCount: dataFilteredCounts.AcresAndCents,
        apartmentCount: dataFilteredCounts.Apartment,
      }));
  
      if (response.status === 204 || !response.data?.properties?.length) {
        setHasMore(false);
        return;
      }
  
      const newData = response.data?.properties || [];
  
      setPropertyList((prev) => (isNext ? [...prev, ...newData] : newData));
      setNextPropertyId(response.data?.next);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setPageLoading(false);
      setLoading(false);
    }
  };
  
  useEffect(() => {
    getPropertyData();
  }, []);

  useEffect(() => {
    if (isSearching) {
      getPropertyData(false, true);
      setIsSearching(false);
    }
  }, [searchTerm, selectedPropertySaleTypeId]);
  

  useEffect(() => {
    if (!isSearching) return;

  
    const fetchSearchResults = async () => {
      await getPropertyData(false, true);
      setIsSearching(false);
    };
  
    fetchSearchResults();
  }, [isSearching]);
  
  const scrollRef = useRef();
  
  useEffect(() => {
    const div = scrollRef.current;
    if (!div) return;
  
    const handleScroll = () => {
      if (
        div.scrollHeight - div.scrollTop - div.clientHeight <= 50 &&
        hasMore &&
        !pageLoading
      ) {
        getPropertyData(true);
      }
    };
  
    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, [hasMore, pageLoading]);

  const filteredProperties = propertyList.filter((property) => {
    if (
      selectedIndex > 0 &&
      property.propertyType !== PropertyTab[selectedIndex].lable
    ) {
      return false;
    }

    return true;
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePropertyClick = (property) => {
    if (property.type === "Layout") {
      const path = userRole === "Admin" ? "/admin" : "/cmo";
      navigate(`${path}/layout-properties-manage`, {
        state: {
          propertyId: property.docId,
          propertyTypeId: PropertyTypeList.find(
            (item) => item.label === property.type
          ).id,
          propertyName: property.name,
          propertySaleType: property.type,
          propertyInfoStatus: true,
        },
      });
    } else if (property.type === "Villa") {
      const path = userRole === "Admin" ? "/admin" : "/cmo";
      navigate(`${path}/villa-properties-manage`, {
        state: {
          propertyId: property.docId,
          propertyName: property.name,
          propertyTypeId: PropertyTypeList.find(
            (item) => item.label === property.type
          ).id,
          propertySaleType: property.type,
          propertyInfoStatus: true,
        },
      });
    } else if (property.type === "Apartment") {
      const path = userRole === "Admin" ? "/admin" : "/cmo";
      navigate(`${path}/apartment-properties-manage`, {
        state: {
          propertyId: property.docId,
          propertyName: property.name,
          propertyTypeId: PropertyTypeList.find(
            (item) => item.label === property.type
          ).id,
          propertySaleType: property.type,
          propertyInfoStatus: true,
        },
      });
    }
  };


const path = getBasePathByUserRole()

  const handleEstimate  = () => {
    navigate(`${path}/estimate-list`);
  };

  const handleSelectedProperty = (property) => {
    if(property?.totalUnits === 0){
      showInfoToast("No available units")
      return
    }
    setSelectedProperty(property.docId);
    setSelectedPropertyName(property.name);
    setSelectedPropertyType(property.type);
    setIsModelOpen(true);
  };
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setIsSearching(true);
  };
  
  const handleFilterProperties = (filterOption) => {
   
    setSelectedPropertySaleTypeId(filterOption?.saleType?.id);
    setSelectedPropertyLocationId(filterOption?.location?.value)
    setIsSearching(true);
  };
  

  const PropertyCardSkeleton = () => {
    return (
      <div className="bg-white p-5 rounded-xl shadow animate-pulse flex flex-col">
        <div className="h-5 w-2/3 bg-gray-300 rounded mb-3"></div>
        <div className="h-40 bg-gray-200 rounded-md mb-4"></div>
        <div className="space-y-2 mb-4">
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>
          <div className="h-4 bg-gray-300 rounded w-1/2"></div>
        </div>
        <div className="mt-auto flex justify-between items-center border-t-2 pt-4">
          <div className="w-1/4 h-5 bg-gray-300 rounded"></div>
          <div className="w-px h-10 bg-gray-200"></div>
          <div className="w-1/4 h-5 bg-gray-300 rounded"></div>
          <div className="w-px h-10 bg-gray-200"></div>
          <div className="w-1/4 h-5 bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-appGrayBackground h-screen flex flex-col">
       <AdminAppBar />
       <ToastContainer/>
       
   
      <div 
        ref={scrollRef} 
        className="flex-1 overflow-y-auto pt-20 pb-16"
        style={{ height: 'calc(100vh - 80px)' }} 
      >
        <div className="px-6 pt-8 pb-6">
          
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <CustomHeading title={"Properties"}  isIcon={true} />

            <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
              <form onSubmit={handleSearchSubmit} className="relative w-full md:w-[385px]">
                <input
                  type="text"
                  placeholder="Search Property Name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  className="w-full pl-3 pr-12 h-[50px] shadow appearance-none border rounded-[10px] text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <button
                  type="submit"
                  className="absolute right-0 w-[50px] h-[50px] top-1/2 transform -translate-y-1/2 text-white bg-customGreen p-2 rounded-r-[10px]"
                >
                  <FiSearch size={25} className="ml-1" />
                </button>
              </form>

              <div className="flex gap-3 w-full md:w-auto">
                <button
                  onClick={handleEstimate}
                  className="flex-1 md:flex-none md:w-[160px] rounded-lg h-[50px] bg-customGreen text-white text-base font-semibold transition hover:bg-opacity-90"
                >
                  Estimate History
                </button>

                <button
                  onClick={() => setIsOpen(true)}
                  className="flex-1 md:flex-none md:w-[160px] rounded-lg h-[50px] bg-customGreen text-white text-base font-semibold transition hover:bg-opacity-90"
                >
                  Create Property
                </button>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between mt-14">
            {/* Property tab list */}
            <div className="flex overflow-x-auto md:justify-start gap-3">
              {loading
                ? Array(4)
                    .fill()
                    .map((_, index) => (
                      <div
                        key={index}
                        className="px-6 h-[50px] shadow rounded-3xl bg-gray-200 animate-pulse w-[140px]"
                      />
                    ))
                : PropertyTab.map((list, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        if(selectedIndex === list.id){

                        }else{
                          setSelectedIndex(list?.id);
                          setIsSearching(true);
                        }
                        
                      }}
                      
                      className={`px-6 h-[50px] rounded-3xl whitespace-nowrap ${
                        selectedIndex === list?.id
                          ? "bg-white text-customGreen text-base font-semibold shadow"
                          : "bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      {list.lable} ({list.count})
                    </button>
                  ))}
            </div>

            {/* {properties filter } */}
            <div className="flex items-center gap-4 ">
              <div
                onClick={() => {
                  setIsVisible(!isVisible);
                }}
                className="bg-customGreen cursor-pointer w-12 h-12 rounded-full flex items-center justify-center"
              >
                <RiEqualizerLine className="text-white text-2xl" />
              </div>
            </div>
          </div>

          {/* Property Card List */}
          {loading ? (
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 gap-6">
              {Array.from({ length: 6 }).map((_, idx) => (
                <PropertyCardSkeleton key={idx} />
              ))}
            </div>
          ) : filteredProperties.length === 0 ? (
            <div className="mt-12 text-center p-8 bg-white rounded-xl shadow">
              <h3 className="text-xl font-semibold text-gray-600">
                No properties found
              </h3>
              <p className="mt-2 text-gray-500">
                Try changing your filters or search term
              </p>
            </div>
          ) : (
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 gap-6">
              {filteredProperties.map((item, index) => (
                <div
                  key={index}
                  className="bg-white cursor-pointer p-5 hover:shadow-xl rounded-xl shadow transition-shadow duration-300 flex flex-col"
                >
                  <div  onClick={() => handlePropertyClick(item)} className="pb-3 border-b-2 border-gray-100">
                    <h3 className="text-lg font-medium">
                      Property:{" "}
                      <span className="text-customGreen font-semibold">
                        {item.name}
                      </span>
                    </h3>
                  </div>

                  <div
                    onClick={() => handlePropertyClick(item)}
                    className="my-3 border-2  relative h-40 overflow-hidden rounded-md"
                  >
                    <img
                      src={item.propertyThumbnail || propertySampleImage}
                      className="w-full h-full object-cover"
                      alt={`${item.name} property`}
                      loading="lazy"
                    />
                    <div className="absolute text- top-3 right-3 border px-3 border-custom-dark-green bg-green-100 text-custom-primaryColor text-xs font-medium  py-1 rounded-full">
                      {item.propertySaleType}
                    </div>
                  </div>

                  <div className="space-y-2 mb-4">
                    <div className="flex items-center">
                      <span className="text-gray-600 w-20">Location:</span>
                      <span className="font-medium">{item.location}</span>
                    </div>
                    <div className="flex items-center">
                      <span className="text-gray-600 w-20">Type:</span>
                      <span className="font-medium">{item.type}</span>
                    </div>
                  </div>

                  <div className="mt-auto flex justify-between items-center border-t-2 border-gray-100 pt-4">
                    <div className="text-center">
                      <span className="block font-semibold text-lg">
                        {item.totalUnits}
                      </span>
                      <span className="text-sm text-gray-600">Total Units</span>
                    </div>

                    <div className="h-10 w-px bg-gray-300"></div>

                    <div className="text-center">
                      <span className="block font-semibold text-lg">
                        {item.availableUnits}
                      </span>
                      <span className="text-sm text-gray-600">Available</span>
                    </div>

                    <div className="h-10 w-px bg-gray-300"></div>

                    <div
                       onClick={() => handleSelectedProperty(item)}
                      // onClick={()=>{
                      //   showInfoToast("Coming Soon...")
                      // }}
                      className="text-center cursor-pointer group"
                    >
                      <div className="flex justify-center">
                        <img
                          src={icons.downloadIcon2}
                          className="w-6 h-6 group-hover:scale-110 transition-transform"
                          alt="Download"
                        />
                      </div>
                      <span className="text-sm text-gray-600">Estimate</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Loading indicator for infinite scroll */}
          {pageLoading && !loading && (
            <div className="mt-6 flex justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-customGreen"></div>
            </div>
          )}
        </div>
      </div>

      <PropertiesSelectingModel
        isOpen={isOpen}
        close={() => {
          setIsOpen(false);
        }}
      />
      <PropertiesFilter
        isSliderOpen={isVisible}
        filterProperty={handleFilterProperties}
        onHide={() => {
          setIsVisible(false);
        }}
      />

      <EstimateGeneration
        isOpen={isModelOpen}
        onClose={() => {
          setIsModelOpen(false);
        }}
        propertyId={selectedProperty}
        selectedPropertyName={selectedPropertyName}
        selectedPropertyType={selectedPropertyType}
      />
      <EstimateHistoryModel
        isOpen={isEstimateModelOpen}
        onClose={() => {
          setIsEstimateModelOpen(false);
        }}
      />
    </div>
  );
};

export default PropertiesListCard;